import { MenuItem } from "../../Types/Layout/SidebarType";

export const CardRechargeMenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
      },
    ],
  },
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Recharge",
        id: 3,
        icon: "project",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/recharge/card_recharge`, type: "link", title: "Card Recharge" },
          { path: `${process.env.PUBLIC_URL}/recharge/recharge_history`, type: "link", title: "Recharge History" },
        ],
      },
    ],
  },
];
